import $ from 'jquery';
import _ from 'lodash';
import constants from 'Constants.js';
import {View} from 'backbone';
import {Model} from 'backbone';
import BaseTableView from 'properties/BaseTableView.js'
import SelectFieldModal from 'common-views/SelectFieldModalView.js';
import FormulaModal from 'common-views/MainFormulaModalView';
import Template from 'behaviors/properties/main/send.ejs';
import eventBus from 'EventBus';
import util from 'util/Util.js';
//=====================================================================
//
// An instance of this view represents a Parameters.
//
// Casey Justus, April 25, 2016
//
//=====================================================================

class MainSendView extends BaseTableView {

    initialize(opts) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.minRows = 6;
        this.$sendSelector = '#gbox_propMainTable > div.ui-jqgrid-view > div.ui-jqgrid-bdiv';
        this.$returnSelector = '#gbox_propMainTable2 > div.ui-jqgrid-view > div.ui-jqgrid-bdiv';
        this.addMinRows = opts.settings ? opts.settings.addMinRows : true;
       
        this.events = {
            "click .itemNew": "itemNew",
            "click .itemRemove": "itemRemove",
            "click .itemUp": "itemUp",
            "click .itemDown": "itemDown",
            "change input[type=checkbox]": "itemCheck"
        };

        this.listenTo(this.model, 'change', this.render); 

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }  
        
        return this;
    }

    itemNew() {
        var gridData = this.model.get('gridData');
        var newRow = {
            'source': 'Source ' + (gridData.length + 1),
            'formula': 'formula' + (gridData.length + 1)
        };
        $(constants.PROP_MAIN_TABLE).addRowData((gridData.length + 1), newRow);

        gridData.push(newRow);
        this.model.set('gridData', gridData);
    }

    onCellSelect(rowId, iCol, cellcontent, e) { 

        const self = this;

        this.model.set('sendPos', $(this.$sendSelector).scrollTop(), constants.MODEL_SILENT);
        this.model.set('returnPos', $(this.$returnSelector).scrollTop(), constants.MODEL_SILENT);
        this.model.set('cellContent', (cellcontent && cellcontent !== "&nbsp;")?cellcontent:undefined, constants.MODEL_SILENT);

        const rowData = $(this.gridEl).getRowData(rowId);
        if (rowData['isDefault']) {
            e.preventDefault();
            return;
        }

        const colNames = this.model.get('colNames');
        if (colNames[iCol] !== 'Source' ) {
            return;
        }

        const  rowIdModel = parseInt(rowId);
        console.log('Row ID Model',rowIdModel);
        console.log('Grid Count',$(this.gridEl).getGridParam("reccount"));
        console.log('Grid Count',$(this.gridEl).getDataIDs());

        let gridData = this.model.get('gridData');
        console.log('Current Grid Data',gridData);
        console.log('Current Grid Data Row',gridData[rowIdModel]);
        
        if (gridData[rowIdModel].formula === 'selected') {
            const attributes = {formulaParameter: this.model.attributes.Request.Send.parameter[rowIdModel].Expression };

            var sfModel = new Model(attributes);
            this.model.set("dataSelectedItemId", 
                this.model.attributes.Request.Send.parameter[rowIdModel]._value, {silent:true});
            const fmModal = new FormulaModal({model: sfModel, config:{viewTitle: "Formula", formula:gridData[rowIdModel].formula}});
            fmModal.render().then( formulaParameter => {
                //gridData[rowIdModel].source = selectedField.name;
                //this.model.set('gridData', gridData,{silent:true});
                //this.render();
                self.model.attributes.Request.Send.parameter[rowIdModel].Expression = formulaParameter;
            }, msg => console.log(msg)).catch( err => console.log(err));
        }
        else {
            console.log('Select Field Modal Opened');
            this.model.set("dataSelectedItemId", 
                this.model.attributes.Request.Send.parameter[rowIdModel]._value, {silent:true});

            const dataType = this.model.attributes.Request.Send.parameter[rowIdModel]._dataType;
            let mode = '';

            if(dataType && !util.isEmpty(dataType) && dataType === "System.Byte"){
                mode = 'file';
                this.model.set('hideSelectFields', true, { silent: true });
            }else{
                this.model.set('hideSelectFields', false, { silent: true });
            }

            const sfModal = new SelectFieldModal({model: this.model, mode, config:{viewTitle: "Select Field", formula:gridData[rowIdModel].formula}});
            sfModal.render().then((selectedField)=> {
                gridData[rowIdModel].source = selectedField.name;
                self.model.set('gridData', gridData,{silent:true});
                self.model.attributes.Request.Send.parameter[rowIdModel]._value = selectedField.id;  
                
                if(mode === "file"){
                    self.model.attributes.Request.Send.parameter[rowIdModel]._value += '$f'; 
                }

                self.model.trigger('change');
            }, msg => console.log(msg)).catch( err => console.log(err));
        }
    }

    itemCheck(e) {
        this.model.set('sendPos', $(this.$sendSelector).scrollTop(), constants.MODEL_SILENT);
        this.model.set('returnPos', $(this.$returnSelector).scrollTop(), constants.MODEL_SILENT);

        let parentCell = $(e.currentTarget).parent();
        let sourceCell = $(e.currentTarget).closest('td').prev('td');
        let i = $(e.currentTarget).closest('tr').index() - 1;
        let gridData = this.model.get('gridData');

        let title = parentCell.attr('aria-describedby').split("_")[1];
        if (title === 'search') {
            gridData[i].search = e.currentTarget.checked ? 'selected' : '';
            this.model.attributes.Request.Send.parameter[i]._show =  e.currentTarget.checked ? 'true' : 'false';
        } else {
            if (e.currentTarget.checked) {
                gridData[i].formula = 'selected';
                gridData[i].source = '[Formula]';
                this.model.attributes.Request.Send.parameter[i]._type = "expression";
                this.model.attributes.Request.Send.parameter[i]._value = "";
            }
            else {
                gridData[i].formula = '';                
                gridData[i].source = '';
                this.model.attributes.Request.Send.parameter[i]._type = "field";
                this.model.attributes.Request.Send.parameter[i]._value = "";
            }
        }

        this.model.set('gridData', gridData, {silent: true});
        this.model.trigger('change');
    } 

    render() {
        super.render();
        let self = this;
        $(this.gridEl).jqGrid('clearGridData');
        this.model.get('gridData').forEach(function (value, index) {
            $(self.gridEl).addRowData(index, value);
        });

        let gridData = $(this.gridEl).jqGrid('getRowData');

        let size = gridData.length;
        if (this.addMinRows && size <= this.minRows) {
            var newRow = {
                'name': '',
                'source': '',
                'formula': '',
                'isDefault': true
            };
            for (let i=size; i<this.minRows; ++i) {
                $(this.gridEl).addRowData((gridData.length + 1), newRow);
            }
        }

        $(this.gridEl).jqGrid('setGridHeight', 'auto');
       

        if(!this.addMinRows){
            $('.format-table-properties').css("height","100%");
        }

        $(this.$sendSelector).scrollTop(this.model.get('sendPos'));
        $(this.$returnSelector).scrollTop(this.model.get('returnPos'));
    } 
}

export default MainSendView;
